module.exports = __webpack_public_path__ + "static/media/logo_franca_medical.4a1f65a8.svg";